export default __webpack_public_path__ + "static/media/2049px.ca606056.png";